// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import i18n from './i18n/index'
import store from './store/index'
import './units/elementui'
/* axios */
import axios from './api'
import api from './api/api'

Vue.prototype.http = axios;
Vue.prototype.api = api;
/* 路由 */
import router from './router'

/* swiper */
import "swiper/css/swiper.css";

/* 重置样式 */
import './assets/css/reset.min.css'
/* 自定义全局样式 */
import './assets/css/main.css'

import './assets/css/base.css'
import './assets/css/home.css'
/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'
import './assets/icons/iconfont.css'
/* animate.css */
import 'animate.css'

/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name, Header)

/* 头部组件 */
import EditDal from './components/editDal'
Vue.component(EditDal.name, EditDal)
/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name, Footer)
/* 文字详情 */
import articleDetail from './components/articleDetail'
Vue.component(articleDetail.name, articleDetail)
import articleDetailLeft from './components/articleDetailLeft'
Vue.component(articleDetailLeft.name, articleDetailLeft)
import articleDetailById from './components/articleDetailById'
Vue.component(articleDetailById.name, articleDetailById)
// 头部banner
import topBanner from './components/topBanner'
Vue.component(topBanner.name, topBanner)
import topImgBanner from './components/topImgBanner'
Vue.component(topImgBanner.name, topImgBanner)

/* 回到顶部 */
import GoTop from './components/GoTop'
import {goMore} from "./units";
Vue.component(GoTop.name, GoTop)

Vue.config.productionTip = false

Vue.prototype.goMore = goMore



new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js